// exposeRequireContext depends on webpack's requireContext
import { exposeRequireContext } from 'live/expose'

// #see: https://webpack.js.org/guides/dependency-management/#requirecontext
const req = require.context(
    './', // require from current directory
    true, // recursive
    // it is important to ignore some folders and files
    /^(?!.*__tests__.*)^(?!.*\.stories\.*)^(?!.*Spec.js)^(?!.*worker.js)^(?!.*__mocks__.*\.js)((.*\.([t|j]sx?\.*))[^.]*$)/
)

// this call expose recursively all the modules on the current folder
// second argument is the prefix of the modules
exposeRequireContext(req, 'plugin-smart-mobility-utils/shared/')
